export function NoTranslate({
  as: Tag = "span",
  children,
  className = "",
  ...props
}) {
  return (
    <Tag className={`notranslate ${className}`} translate="no" {...props}>
      {children}
    </Tag>
  );
}
